export const LOCKED_ICON = 'LOCKED_ICON';
export const LOCKED_SUBTITLE = 'Login to your account';

export const EXPERIMENT_ORDER_VARIANTS = {
  VARIANT_A: 'postorder_default_A',
  VARIANT_B: 'postorder_default_B',
};

export const ACCOUNT_ORDER_CAROUSEL_AB = 'account_order_carousel';
export const ACCOUNT_ORDER_CAROUSEL_A = 'account_order_carousel-a';